import React, { useState } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { Ring } from 'react-awesome-spinners';
import { connect } from 'react-redux';
import { SelectedTable, FormButton, FormButtonsWrap, ErrorsBlock, LoaderWrap, FormLabel, FormHeading, DescriptionInput, IconWrap } from '../';
import { columns } from '../../util/config';
import { unselectAllRecord, pushMessage } from '../../actions';
import { REJECT_REQUEST, approvals, organizationBEABudget } from '../../graphql';

const RejectRequest = props => {
  const { selectedRequests, account, hideModal, unselectAllRecord, pushMessage } = props;
 
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitErrors, setSubmitErrors] = useState([]);

  const [rejectRequest] = useMutation(REJECT_REQUEST);

  const handleQuit = event => { hideModal(); unselectAllRecord('requests'); };

  const handleCommentChange = event => setComment(event.target.value);

  const handleRejectSend = async event => {
    setIsSubmitting(true);
    setSubmitErrors([]);

    if (!comment) {
      setSubmitErrors(['Comment is required!']);
      setIsSubmitting(false);
      return null;
    }

    const results = await Promise.all(selectedRequests.map(async ({
        employee_request_id,
        approver_level
      }) => {
      try {
        // R2 - HR Page (comments)
        await rejectRequest({
          variables: { employee_request_id, approver_level, comment },
          awaitRefetchQueries: true,
          refetchQueries: [
            { query: approvals, variables: { 
              // TODO - get this from PendingRequests.js state 
              where: { approver_pers_no: { eq: account.pers_no }, approval_status: {eq: 'active' } },
              orderBy: [ { column: "employee_request_id", order: "DESC" } ],
              limit: 20,
              offset: 0
            } },
            {
              query: organizationBEABudget,
              variables: {
                where: { year: { eq: new Date().getFullYear().toString() } },
              },
            },
          ]
        });
        
        return {[employee_request_id]: false};
      } catch(e) {
        return {[employee_request_id]: e.message};
      } 
    }));

    const errors = results.filter(r => Object.keys(r).find(p_no => r[p_no]));
    if (!errors.length) {
      hideModal();
      unselectAllRecord('requests');
      pushMessage({
        type: 'success',
        message: 'Request(s) successfully rejected.'
      })
    } else {
      setSubmitErrors(errors.map(e => Object.values(e).shift()));
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <FormHeading>Reject requests</FormHeading>
      <FormLabel>Selected requests: {selectedRequests.length}</FormLabel>
      <SelectedTable
        recordType="requests"
        items={selectedRequests}
        columns={columns.rejectRequests}
      />
      <FormLabel>Comment</FormLabel>
      <DescriptionInput
        name='comment'
        onChange={handleCommentChange}
      />
      {submitErrors.length > 0 && submitErrors.map(err => {
        return (
          <ErrorsBlock key={Math.random()}>
            <IconWrap>!</IconWrap>
            {err}
          </ErrorsBlock>
        );
      })}
      <FormButtonsWrap>
        <FormButton onClick={handleQuit}>Quit</FormButton>
        <FormButton primary disabled={isSubmitting} onClick={handleRejectSend}>Reject</FormButton>
        {isSubmitting && <LoaderWrap><Ring color={'#001235'} size='2' sizeUnit='rem' /></LoaderWrap>}
      </FormButtonsWrap>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    selectedRequests: state.selectedRequests,
    account: state.account
  };
};

export default connect(
  mapStateToProps,
  { unselectAllRecord, pushMessage }
)(RejectRequest);
